export default {
  status: {
    open: 'Åben',
    closed: 'Lukket',
  },
  offline_until: 'Offline indtil',
  closed_until: 'Lukket indtil',
  online_orders_paused: 'Onlinebestillinger sat på pause',
  online_orders_paused_until: 'Onlinebestillinger på pause indtil',
  reopens: 'Genåbner',
  opens_today: 'Åbner i dag',
  opens: 'Åbner',
  open: 'Åben',
  open_whole_day: 'Åben hele dagen',
  outside_ordering_times: 'Uden for bestillingstider',
};
